import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  selectionHeading: {
    color: theme.palette.black.main,
    fontSize: '14px',
    textAlign: 'left',
    margin: theme.spacing(1.75, 0, 2, 0),
  },
  container: {
    marginTop: theme.spacing(6),
  },
  root: {
    marginTop: theme.spacing(3),
    textAlign: 'left',
  },
  textField: {
    width: '211px',
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  labelText: {
    color: theme.palette.black.main,
    fontSize: '14px',
    textAlign: 'left',
    margin: theme.spacing(1.75, 0, 2, 0),
  },
  checkIcon: {
    color: theme.palette.opaque.dark,
    '&.MuiSvgIcon-root': {
      fontSize: '16px',
    },
    marginRight: theme.spacing(1),
  },
  updateRow: {
    display: 'flex',
    padding: theme.spacing(1, 0),
    gap: theme.spacing(3),
  },
  dimensionsBody: {
    paddingTop: theme.spacing(3),
    minHeight: theme.spacing(16),
  },
  description: {
    flexGrow: 1,
  },
  closeIconButton: {
    padding: theme.spacing(0),
    alignSelf: 'center',
  },
  closeIcon: {
    '&.MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      color: theme.palette.icon.main,
    },
  },
  customDimensionsRowsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  addButtonContainer: {
    margin: theme.spacing(3, 0, 0, 0),
    textAlign: 'left',
    marginTop: '16px',
  },
  AUDContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '500px',
  },
  dimensionDivider: {
    marginTop: '40px',
    marginBottom: '32px',
  },
  dimensionsMargin: {
    marginTop: theme.spacing(3),
  },
  AUDRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  labelTextWidth: {
    width: '250px',
  },
}))
